module.exports = __webpack_public_path__ + "img/1463.9cf9dcdc.gif";